import React from 'react';
import { Input, Icon } from 'antd';
import cn from 'classnames';
import FormItem from '../FormItem/FormItem';
import styles from './TextField.module.scss';

const TextField = ({
  label,
  form,
  name,
  options,
  className,
  inline = false,
  colon = false,
  inputProps,
  onRemoveField,
  ...props
}) => {
  return (
    <FormItem
      {...props}
      inline={inline}
      colon={colon}
      label={label}
      className={className}
    >
      <span
        className={cn(styles.inputWrapper, {
          [styles.addonAfter]: inputProps?.addonAfter,
        })}
      >
        {form.getFieldDecorator(name, options)(<Input {...inputProps} />)}
        {typeof onRemoveField === 'function' && (
          <Icon
            className={styles.removeIcon}
            type="minus-circle-o"
            onClick={onRemoveField}
          />
        )}
      </span>
    </FormItem>
  );
};

export default TextField;
